export const VOUCHER_ROUTING_CONSTANTS = {
  ROUTES: {
    VOUCHER: 'voucher',
    MAIN: ':id',
  },
};
